import React from "react"
import { Column } from "@ui-kit/helpers"
import tw, { styled } from "twin.macro"

//import Icon from '../wifi'

import WifiIcon from "../../assets/connection-indicator-large.inline.svg"

const EntityQueue = ({ title, body, r: { queue }, ...props }) => {
  return (
    <Style className="promotion promotion--queue" {...props}>
      {queue && (
        <Column>
          {title && <h2>{title}</h2>}
          <ul>
            {queue?.r.items.map((item, i) => (
              <li key={i}>
                <span className={`icon icon--${i}`}>
                  <WifiIcon />
                </span>

                <h3>{item.name}</h3>
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{ __html: item.description.html }}
                />
              </li>
            ))}
          </ul>
          {body && <footer dangerouslySetInnerHTML={{ __html: body.html }} />}
        </Column>
      )}
    </Style>
  )
}
export default EntityQueue

const Style = styled.section`
  white-space: normal;
  ${tw`whitespace-normal text-gray-300`}

  h2 {
    ${tw`font-display text-4xl xl:text-5xl font-normal text-center mb-4`}
  }

  ul {
    ${tw`list-none flex p-0 m-0 flex-wrap gap-8 mt-16 md:mt-20`}

    > li {
      ${tw`md:w-1/2 md:flex-1 lg:w-1/4 text-center`}
    }
  }

  .icon {
    ${tw`inline-flex items-end [height:80px]`}

    &:not(.icon--3) path:last-child {
      ${tw`[stroke:transparent]`}
    }

    &--0 path:nth-child(n + 3) {
      ${tw`[stroke:#e9e9e9]`}
    }
    &--1 path:nth-child(n + 4) {
      ${tw`[stroke:#e9e9e9]`}
    }
  }

  h3 {
    ${tw`text-gray-500 text-center [fontWeight:600] [fontSize:calc(.6em + 1vmax)] mt-4`}
  }

  .prose {
    ${tw`text-left text-gray-500 xl:px-8`}
  }

  footer {
    ${tw`text-sm px-4 mt-6 lg:mt-10 mg:mt-20 text-gray-600 mx-auto space-y-3 `}

    p {
      ${tw`mb-0`}
    }
  }
`
